const qwest = require('qwest');
const ENDPOINT = {
  CONTACT_REQUEST: '/badtoelz-api/contact/send'
};

class BadToelzAPI {
	constructor(baseUrl = '') {
		this.baseUrl = baseUrl;
	}

	sendContactRequest(name, email, message) {
		return qwest.post(ENDPOINT.CONTACT_REQUEST, {
			contactData: { name, email, message }
		});
	}
}

module.exports = BadToelzAPI;
